import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormsModule,ReactiveFormsModule, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';

import { TCountry, TRegion } from '@core/api/countries/types';
import { CountriesService } from '@shared/services/countries.service';

import { SearchFilterPipe } from '../../../../../shared/pipes/search-filter.pipe';

@Component({
    selector: 'app-countries-allowed',
    templateUrl: './countries-allowed.component.html',
    styleUrls: ['./countries-allowed.component.scss'],
    standalone: true,
    imports: [
      MatFormField,
      MatInput,
      ReactiveFormsModule,
      FormsModule,
      MatIcon,
      MatSuffix,
      MatButton,
      MatTooltip,
      MatSelect,
      MatOption,
      SearchFilterPipe,
    ],
})
export class CountriesAllowedComponent implements OnInit, OnDestroy {
  private _subs: Subscription[] = [];
  countries: TCountry[] = [];
  regions: TRegion[] = [];
  searchCountry = '';
  searchRegion = '';

  public countryForm = this.fb.nonNullable.group({
    name: ['', Validators.required],
  });

  public regionForm = this.fb.nonNullable.group({
    name: ['', Validators.required],
    countries: [[] as TCountry[], Validators.required],
  });

  constructor(
    private _countriesService: CountriesService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this._countriesService.getCountriesAndRegions();
    const { countries, regions } = this._countriesService.getCountriesAndRegionsObservable();

    this._subs.push(
      countries.subscribe(response => {
        this.countries = response;
      })
    );
    this._subs.push(
      regions.subscribe(response => {
        this.regions = response;
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.forEach(sub => sub.unsubscribe());
  }

  public addCountry(): void {
    this._countriesService.addCountry({ name: this.countryForm.value.name as string });
    this.countryForm.setValue({ name: '' });
  }

  public deleteCountry(id: string): void {
    this._countriesService.deleteCountry(id);
  }

  public addRegion(): void {
    this._countriesService.addRegion({
      name: this.regionForm.value.name as string,
      countries: this.regionForm.value.countries as TCountry[],
    });
    this.regionForm.setValue({ name: '', countries: [] });
  }

  public deleteRegion(id: string): void {
    this._countriesService.deleteRegion(id);
  }

  public regionCountries(region: TRegion): string {
    return region.countries.map(country => country.name).join(', ');
  }

  protected clearSearchCountry() {
    this.searchCountry = '';
  }

  protected clearSearchRegion() {
    this.searchRegion = '';
  }
}
